// Запятая — обычный ввод процента с клавиатуры, Number её не понимает.
export const parsePercent = (value: string): number | null => {
    const trimmed = value.trim().replace(",", ".");
    const percent = Number(trimmed);

    if (trimmed === "" || !Number.isFinite(percent) || percent < 0 || percent > 100) return null;

    return percent;
};

export const formatPercent = (percent: number): string =>
    `${percent.toLocaleString("ru-RU")} %`;
